import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js'
import { AuthUser } from '../login/administrador/AuthUser';


enum StorageKey {
  CurrentUser = 'vtvg',
  CurrentGrad = 'jfrh',
  CurrentComp = 'Uy4f',
  CurrentProf = '3yUp',
  CurrentAdmin = 'la8d',
  InfoEgresado = 'lM7m',
  InfoEmpresa = '40Ft'
}

@Injectable()
export class AuthService {

  constructor() {}
  getToken(): string {
    const token = (this.getUser() as AuthUser);
    if (localStorage.getItem(StorageKey.CurrentUser) !=null && token != null) {
      return token.token;
    }
    return null;
  }

  saveUser(authUser)
  {
    const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
    const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
    const jsonObjectString = JSON.stringify(authUser);
    const encryptedData = CryptoJS.AES.encrypt(jsonObjectString, key, {iv:iv}).toString();
    localStorage.setItem(StorageKey.CurrentUser, encryptedData);
  }

  getUser()
  {
    if(localStorage.getItem(StorageKey.CurrentUser))
    {
      const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
      const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
      return this.parseJson(CryptoJS.AES.decrypt(localStorage.getItem(StorageKey.CurrentUser), key, {iv:iv}).toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  parseJson(decrypt)
  {
    return JSON.parse(decrypt);
  }

  saveInfoGraduado(object:any)
  {
    const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
    const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
    const jsonObjectString = JSON.stringify(object);
    const encryptedData = CryptoJS.AES.encrypt(jsonObjectString, key, {iv:iv}).toString();
    localStorage.setItem(StorageKey.InfoEgresado, encryptedData);
  }
  
  saveGraduado(object:any)
  {
    const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
    const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
    const jsonObjectString = JSON.stringify(object);
    const encryptedData = CryptoJS.AES.encrypt(jsonObjectString, key, {iv:iv}).toString();
    localStorage.setItem(StorageKey.CurrentGrad, encryptedData);
  }

  saveComp(object:any)
  {
    const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
    const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
    const jsonObjectString = JSON.stringify(object);
    const encryptedData = CryptoJS.AES.encrypt(jsonObjectString, key, {iv:iv}).toString();
    localStorage.setItem(StorageKey.InfoEmpresa, encryptedData);
  }


  saveProf(object:any)
  {
    const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
    const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
    const jsonObjectString = JSON.stringify(object);
    const encryptedData = CryptoJS.AES.encrypt(jsonObjectString, key, {iv:iv}).toString();
    localStorage.setItem(StorageKey.CurrentProf, encryptedData);
  }


  saveAdmin(object:any)
  {
    const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
    const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
    const jsonObjectString = JSON.stringify(object);
    const encryptedData = CryptoJS.AES.encrypt(jsonObjectString, key, {iv:iv}).toString();
    localStorage.setItem(StorageKey.CurrentAdmin, encryptedData);
  }

  getInfoGrad() : any
  {
    if(localStorage.getItem(StorageKey.InfoEgresado))
    {
      const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
      const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
      return this.parseJson(CryptoJS.AES.decrypt(localStorage.getItem(StorageKey.InfoEgresado), key, {iv:iv}).toString(CryptoJS.enc.Utf8));  
    }
    return null;
  }

  getGraduated() : any
  {
    if(localStorage.getItem(StorageKey.CurrentGrad))
    {
      const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
      const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
      return this.parseJson(CryptoJS.AES.decrypt(localStorage.getItem(StorageKey.CurrentGrad), key, {iv:iv}).toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  getComp() : any
  {
    if(localStorage.getItem(StorageKey.InfoEmpresa))
    {
      const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
      const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
      return this.parseJson(CryptoJS.AES.decrypt(localStorage.getItem(StorageKey.InfoEmpresa), key, {iv:iv}).toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  getProf() : any
  {
    if(localStorage.getItem(StorageKey.CurrentProf))
    { 
      const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
      const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
      return this.parseJson(CryptoJS.AES.decrypt(localStorage.getItem(StorageKey.CurrentProf), key, {iv:iv}).toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  getAdmin() : any
  {
    if(localStorage.getItem(StorageKey.CurrentAdmin))
    {
      const key = CryptoJS.enc.Hex.parse('2b7e151628aed2a6abf7158809cf4f3c');
      const iv = CryptoJS.enc.Hex.parse('3ad77bb40d7a3660a89ecaf32466ef97');
      return this.parseJson(CryptoJS.AES.decrypt(localStorage.getItem(StorageKey.CurrentAdmin), key, {iv:iv}).toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  logoutGraduated()
  {
    return new Promise<void>((resolve, reject) => {
        //eliminar user
        localStorage.removeItem(StorageKey.CurrentUser);
        //eliminar info egresado
        localStorage.removeItem(StorageKey.CurrentGrad);
        
        localStorage.removeItem(StorageKey.InfoEgresado);

        
        resolve();
      }); 
  }
  logoutCompany()
  {
    return new Promise<void>((resolve, reject) => {
        //eliminar user
        localStorage.removeItem(StorageKey.CurrentUser);
        //eliminar info empresa
        localStorage.removeItem(StorageKey.CurrentComp);
        
        localStorage.removeItem(StorageKey.InfoEmpresa);
        resolve();
      }); 
  }
  logoutProfessor()
  {
    return new Promise<void>((resolve, reject) => {
        //eliminar user
        localStorage.removeItem(StorageKey.CurrentUser);
        localStorage.removeItem(StorageKey.CurrentProf); 
        resolve();
      }); 
  }
  logoutAdmin()
  {
    return new Promise<void>((resolve, reject) => {
        //eliminar user
        localStorage.removeItem(StorageKey.CurrentUser);
        localStorage.removeItem(StorageKey.CurrentAdmin); 
        resolve();
      }); 
  }
}
